import {StyleSheet} from 'react-native';

import {yellow, yellowDarker} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  base: {},
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  label: {
    backgroundColor: yellow,
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 3,
    marginBottom: 20,
  },
  labelText: {
    color: yellowDarker,
  },
  text: {
    flex: 1,
    marginBottom: 10,
  },
});
